// extracted by mini-css-extract-plugin
module.exports = {"root":"_29QYd","small":"_1fnis","medium":"_1Fyqe","large":"_36bZd","noBorder":"_1ElkT","filled":"_1XVW8","fullWidth":"_1-qO6"};